import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shared-ui-key-value-view-line',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './key-value-view-line.component.html',
  styleUrls: ['./key-value-view-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeyValueViewLineComponent {
  @Input() readonly alignDirection: 'left' | 'right' | 'center' = 'left';
  @Input() readonly key: string = '';
}
